import { http, filterParams } from '../../http'
import { apiHeaders, apiBasePath } from '../../../config/api'

const servicePath = 'web/contents'

const contentParams = {
  id: {
    type: 'int',
    array: false
  },
  title: {
    type: 'string',
    array: false
  },
  preview: {
    type: 'int',
    array: false
  }
}

const feedParams = {
  platform: {
    type: 'string',
    array: false
  },
  platform_id: {
    type: 'int',
    array: true
  },
  section: {
    type: 'string',
    array: false
  },
  section_id: {
    type: 'int',
    array: true
  },
  category: {
    type: 'string',
    array: false
  },
  category_id: {
    type: 'int',
    array: true
  },
  product: {
    type: 'string',
    array: false
  },
  product_id: {
    type: 'int',
    array: true
  },
  editor_id: {
    type: 'int',
    array: true
  },
  highlighted: {
    type: 'int',
    array: true
  },
  tag: {
    type: 'string',
    array: true
  },
  limit: {
    type: 'int',
    array: false,
    default: 12
  },
  offset: {
    type: 'int',
    array: false,
    default: 0
  }
}

export const getContent = (requestParams, log) => {
  const url = `${apiBasePath}/${servicePath}`
  const data = filterParams(requestParams, contentParams)
  return new Promise((resolve, reject) => {
    http(url, 'get', data, apiHeaders)
      .then((response) => {
        const request = response.data
        if (request.status === false && log === true) {
          console.error(request.message)
        }
        resolve(request.data.content)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export const getRelatedContents = (requestParams, log) => {
  const url = `${apiBasePath}/${servicePath}/related`
  const data = filterParams(requestParams, contentParams)
  return new Promise((resolve, reject) => {
    http(url, 'get', data, apiHeaders)
      .then((response) => {
        const request = response.data
        if (request.status === false && log === true) {
          console.error(request.message)
        }
        resolve(request.data)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export const getContentFeed = (requestParams, log) => {
  const url = `${apiBasePath}/${servicePath}`
  const data = filterParams(requestParams, feedParams)
  return new Promise((resolve, reject) => {
    http(url, 'get', data, apiHeaders)
      .then((response) => {
        const request = response.data
        if (request.status === false && log === true) {
          console.error(request.message)
        }
        resolve(request.data.contents)
      })
      .catch((error) => {
        reject(error)
      })
  })
}
